import type { ReactNode } from 'react'
import { BarChart3, ChefHat, CircleGauge, LogOut, MonitorCog, UtensilsCrossed } from 'lucide-react'
import { NavLink, Navigate, useLocation } from 'react-router-dom'
import { useLamsa } from '../context/LamsaContext'
import BrandMark from './BrandMark'

export default function StaffShell({ children, title }: { children: ReactNode; title: string }) {
  const { restaurant, branch, staffProfile, signOutStaff, backendMode, loading } = useLamsa()
  const location = useLocation()

  if (loading) return <div className="full-center">Loading Lamsa Table…</div>
  if (!staffProfile) return <Navigate to="/login" replace state={{ from: location.pathname }} />

  return (
    <div className="staff-app">
      <aside className="staff-sidebar">
        <BrandMark />
        <nav>
          <NavLink to="/app/foh"><CircleGauge size={18} />Front of House</NavLink>
          <NavLink to="/app/boh"><ChefHat size={18} />Back of House</NavLink>
          <NavLink to="/app/manage"><BarChart3 size={18} />Management</NavLink>
          <NavLink to="/app/studio"><MonitorCog size={18} />Studio</NavLink>
        </nav>
        <div className="sidebar-spacer" />
        <div className="sidebar-restaurant"><UtensilsCrossed size={16} />{restaurant.name}</div>
        <button className="sidebar-signout" onClick={() => void signOutStaff()}><LogOut size={16} />Sign out</button>
      </aside>
      <main className="staff-main">
        <header className="staff-topbar">
          <div>
            <span className="eyebrow">{restaurant.name} · {branch.name}</span>
            <h1>{title}</h1>
          </div>
          <div className="topbar-meta">
            <span className={`backend-chip ${backendMode}`}>{backendMode === 'demo' ? 'Demo data' : 'Supabase live'}</span>
            <div className="user-chip"><strong>{staffProfile.displayName}</strong><span>{staffProfile.role}</span></div>
          </div>
        </header>
        <div className="staff-content">{children}</div>
      </main>
      <div className="staff-mobile-blocker">
        <BrandMark />
        <h2>Staff workspace requires a tablet or laptop.</h2>
        <p>Open Lamsa staff tools on a landscape tablet or desktop browser.</p>
      </div>
    </div>
  )
}
